import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import _ from 'lodash'

import PropTypes from 'prop-types'
import { withGoogleMap, GoogleMap, Marker } from 'react-google-maps'
import { geoSuggestToLocation, getLatLngByAddress } from './../../../../libs/utils'
import Autocomplete from 'react-google-autocomplete'
import Loader from './../../../UI/Loader'
import UPDATE_LOCAL_TOUR from './../../../../graphql/ActivitySteps/UpdateLocalTourMeetingPoint.graphql'
import { NotificationManager } from 'react-notifications'

const MapComponent = withGoogleMap(
  ({ containerElement = <div style={{ height: '100%' }} />, mapElement = <div style={{ height: '100%' }} />, ...props }) => (
    <GoogleMap ref={props.onMapLoad} defaultZoom={16} center={props.location} onClick={props.onMapClick}>
      {props.markers.map((marker, index) => (
        <Marker
          {...marker}
          key={index}
          onRightClick={() => {
            props.onMarkerRightClick(index)
          }}
        />
      ))}
    </GoogleMap>
  )
)

class MeetingPoint extends Component {
  static propTypes = {
    data: PropTypes.shape({
      allLocalTours: PropTypes.array
    }),
    history: PropTypes.object,
    currentSteps: PropTypes.object,
    updateSteps: PropTypes.func,
    updateLocalTour: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      saving: false,
      place: '',
      placeError: false,
      country: ''
    }
  }

  componentWillMount() {
    if (this.props.currentSteps.meetingPoint) {
      this.setState((state, props) => ({
        geoLocation: geoSuggestToLocation(props.currentSteps.meetingPoint),
        markers: [
          {
            position: {
              lat: props.currentSteps.meetingPoint.lat,
              lng: props.currentSteps.meetingPoint.lng
            },
            key: props.currentSteps.meetingPoint.description,
            defaultAnimation: 2
          }
        ],
        place: props.currentSteps.meetingPoint.description,
        country: props.currentSteps.meetingPoint.country ? props.currentSteps.meetingPoint.country : ''
      }))
    } else {
      this.setState(() => ({
        markers: [
          {
            position: {
              lat: 25.0112183,
              lng: 121.52067570000001
            },
            key: 'Taiwan',
            defaultAnimation: 2
          }
        ]
      }))
    }
  }

  componentDidMount = () => {
    const input = document.getElementById('auto_div')
    this.props.currentSteps.meetingPoint &&
      this.props.currentSteps.meetingPoint.description &&
      (input.placeholder = this.props.currentSteps.meetingPoint.description)
  }

  handleSubmit() {
    const { data, history } = this.props
    const localTour = _.head(data.allLocalTours)
    const marker = _.head(this.state.markers)

    this.setState(
      () => ({
        saving: true
      }),
      async () => {
        if (!this.state.place && !_.head(data.allLocalTours).meetingPoint.id) {
          this.setState(() => ({
            placeError: true
          }))
        } else {
          let meetingPoint

          if (Array.isArray(data.allLocalTours) && localTour && localTour.meetingPoint && localTour.meetingPoint.id) {
            meetingPoint = {
              lat: marker.position.lat,
              lng: marker.position.lng,
              description: this.state.place,
              country: this.state.country
            }
          } else {
            meetingPoint = {
              lat: marker.position.lat,
              lng: marker.position.lng,
              description: this.state.place,
              country: this.state.country
            }
          }

          await this.props.updateLocalTour({
            variables: {
              id: this.props.currentSteps.id,
              meetingPoint
            }
          })

          this.setState(
            () => ({
              saving: false
            }),
            () => {
              NotificationManager.success('Meeting point updated', 'Success', 5000)
              this.props.updateSteps()
              if (Array.isArray(data.allLocalTours) && localTour) {
                history.push(`/activity-steps/${localTour.id}/length-price`)
              } else {
                history.push('/activity-steps/length-price')
              }
            }
          )
        }
      }
    )
  }

  onPlaceSelect(place, address) {
    const country = address ? _.head(address.filter(item => item.types.includes('country'))).long_name : ''
    this.setState(
      () => ({ place, country }),
      async () => {
        const { center } = await getLatLngByAddress(this.state.place)

        this.setState(() => ({
          markers: [
            {
              position: {
                lat: center.lat,
                lng: center.lng
              },
              defaultAnimation: 2
            }
          ],
          placeError: false
        }))
      }
    )
  }

  onPlacesError(status) {
    if (status !== 'ZERO_RESULTS') {
      console.warn('GOOGLE PLACES ERROR', status)
    }
  }

  render() {
    const { t } = this.props
    const { markers } = this.state

    if (this.props.loading) {
      return <Loader showLoader={true} />
    }

    return (
      <div className="steps-screen__form step-form faded-container">
        <div className="steps-screen__form-title">{t('meeting_point')}</div>
        <div className="steps-screen__form-input-area">
          <div className="form-group">
            <label className="steps-screen__form-input-label" style={{ fontSize: 20, lineHeight: '24px' }}>
              {t('meeting_point_description')}
            </label>
            <Autocomplete
              id="auto_div"
              style={{ width: '100%', height: 48 }}
              onError={status => this.onPlacesError(status)}
              onPlaceSelected={place => {
                this.onPlaceSelect(place.formatted_address, place.address_components)
              }}
              types={['address']}
            />
            <small className={this.state.placeError ? 'text-danger' : 'hidden'}>{t('main:required_field')}</small>
          </div>
          <div className="google-map-wrapper">
            <MapComponent
              containerElement={<div style={{ height: '100%' }} />}
              mapElement={<div style={{ height: '100%' }} />}
              markers={markers}
              location={_.head(markers).position}
            />
          </div>
        </div>
        <button
          className="btn btn-lg btn-primary btn-danger steps-submit-btn"
          onClick={() => {
            this.handleSubmit()
          }}
        >
          {t('main:save_continue')}
        </button>
      </div>
    )
  }
}

export default compose(
  translate('activity_steps'),
  graphql(UPDATE_LOCAL_TOUR, {
    name: 'updateLocalTour'
  }),
  withRouter
)(MeetingPoint)



// WEBPACK FOOTER //
// src/components/ActivitySteps/Steps/TimesLocation/MeetingPoint.jsx